import 'nodelist-foreach-polyfill'
import 'formdata-polyfill'

window.addEventListener('DOMContentLoaded', () => {
  const eventSearchForm = document.getElementById('event-search-form')

  eventSearchForm.addEventListener('submit', (e) => {
    e.preventDefault()

    const formData = new FormData(eventSearchForm);
    const url = new URL(eventSearchForm.action, window.location.origin);

    // Remove all existing search parameters
    url.search = '';

    // Append only non-empty parameters
    for (const [key, value] of formData.entries()) {
      if (value.trim() !== '') {
        url.searchParams.append(key, value);
      }
    }

    window.location.href = url.toString();
  })
})
